const SERVER_ERRORS_DIRECTIVE_TPL = `
    <div class="text-danger" ng-show="errors.has(field)">
        <span ng-repeat="message in errors.messages(field)"
              ng-bind-html="message">
        </span>
    </div>
`;

angular.module('dnecom')
   .directive('serverErrors', function() {
        return {
            restrict: "E",
            scope: {
                errors: '=errors',
                field: '@field'
            },
            template: SERVER_ERRORS_DIRECTIVE_TPL,
        };
    })
;
